"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateAddress = void 0;
const web3_js_1 = require("@solana/web3.js");
function translateAddress(address) {
    if (typeof address === "string") {
        const pk = new web3_js_1.PublicKey(address);
        return pk;
    }
    else {
        return address;
    }
}
exports.translateAddress = translateAddress;
//# sourceMappingURL=translateAddress.js.map